import React from 'react';
import { pianoIcon } from '@chordbaker/design';

interface PianoIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const PianoIcon: React.FC<PianoIconProps> = ({
  className,
  size = 12,
  color = 'currentColor'
}) => {
  const rect0 = pianoIcon.elements[0] as { x: number; y: number; width: number; height: number; rx?: number };
  const line0 = pianoIcon.elements[1] as { x1: number; y1: number; x2: number; y2: number };
  const line1 = pianoIcon.elements[2] as { x1: number; y1: number; x2: number; y2: number };
  const rect1 = pianoIcon.elements[3] as { x: number; y: number; width: number; height: number; fill?: string };
  const rect2 = pianoIcon.elements[4] as { x: number; y: number; width: number; height: number; fill?: string };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={pianoIcon.viewBox}
      fill={pianoIcon.fill}
      stroke={color}
      strokeWidth={pianoIcon.strokeWidth}
      strokeLinecap={pianoIcon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
      strokeLinejoin={pianoIcon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
      className={className}
    >
      <rect x={rect0.x} y={rect0.y} width={rect0.width} height={rect0.height} rx={rect0.rx} />
      <line x1={line0.x1} y1={line0.y1} x2={line0.x2} y2={line0.y2} />
      <line x1={line1.x1} y1={line1.y1} x2={line1.x2} y2={line1.y2} />
      <rect x={rect1.x} y={rect1.y} width={rect1.width} height={rect1.height} fill={color} />
      <rect x={rect2.x} y={rect2.y} width={rect2.width} height={rect2.height} fill={color} />
    </svg>
  );
};

export default PianoIcon;
